import React, { useEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";
import { ToastContainer, toast } from "react-toastify";
import { modalEventListener } from "../../../utils/ModalEventListener";
import SingleSelectDropDown from "../../../layouts/SingleSelectDropDown";
import {
  CANCELLED_TXN_REASON,
  HOLD_TRANSACTION_REASON,
} from "../../../utils/constant";
import { updateTransaction } from "../../../utils/bankbox";
import ModalWrapper from "../../../layouts/ModalWrapper";

const ReasonsModal = ({
  reasonModalProps,
  bankBoxPanelState,
  setBankBoxPanelState,
  fetchListData,
  closeReasonsModal,
  showReasonModal,
}) => {
  const ref = useRef(null);

  const [state, setState] = useState({
    reasonType: "",
    comments: "",
    showComments: false,
  });

  useEffect(() => {
    return modalEventListener(ref, closeReasonsModal);
  }, [closeReasonsModal]);

  const handleInputChange = (e) => {
    const { value, name } = e.target;

    if (name === "reasonType") {
      state.showComments = value === "Others";
    }

    setState({
      ...state,
      [name]: value,
    });
  };

  const submitReasons = async () => {
    const { txnNo, reqType } = reasonModalProps;
    let { reasonType, comments } = state;

    if (!txnNo || !reqType) return;
    toast.dismiss();
    if (!reasonType)
      return toast.error("Please select reason", { theme: "colored" });
    if (reasonType === "Others" && comments.trim() === "")
      return toast.error("Please enter other reason", { theme: "colored" });

    if (reasonType === "Others") {
      reasonType = `${reasonType} : ${comments}`;
    }

    await updateTransaction(
      "",
      txnNo,
      reqType,
      reasonType,
      "",
      setBankBoxPanelState,
      fetchListData
    );
    setState({ ...state, reasonType: "", resubmitReason: "" });
  };

  return ReactDOM.createPortal(
    <ModalWrapper show={showReasonModal} onClose={closeReasonsModal}>
      <div className="modal-wrapper">
        <ToastContainer
          closeOnClick={false}
          draggable={false}
          closeButton={false}
        />
        <div className="txn-reason-modal-content" ref={ref}>
          <div className="modal-header">
            <button type="button" className="close" onClick={closeReasonsModal}>
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 className="modal-title" id="assignCheckerModal">
              Reason
            </h4>
          </div>
          <div className="modal-body clearfix">
            <SingleSelectDropDown
              dataArr={
                reasonModalProps.reqType === "hold"
                  ? HOLD_TRANSACTION_REASON
                  : CANCELLED_TXN_REASON
              }
              handleChange={(e) => handleInputChange(e)}
              name="reasonType"
              required={true}
              value={state.reasonType}
              divClassName="form-group mrg-T15"
              className="txn-rsn txn-rsn-hold"
            />
            {state.showComments ? (
              <div className="form-group mrg-T15">
                <textarea
                  id="txnReason"
                  style={{ width: "270px", height: "130px" }}
                  name="comments"
                  onChange={(e) => handleInputChange(e)}
                ></textarea>
              </div>
            ) : (
              ""
            )}
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn rc-btn_rset pad-L20 pad-R20"
              onClick={closeReasonsModal}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn rc-btn_primary pad-L20 pad-R20"
              onClick={submitReasons}
            >
              Procees
            </button>
          </div>
        </div>
      </div>
    </ModalWrapper>,
    document.querySelector(".myPortalModalDiv")
  );
};

export default ReasonsModal;
